import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PscCommonDialog } from './models/psc-common-dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  private confirmDialogSubject: Subject<PscCommonDialog> = new Subject<PscCommonDialog>();
  readonly confirmDialogObservable$: Observable<PscCommonDialog> = this.confirmDialogSubject.asObservable();

  private infoDialogSubject: Subject<string> = new Subject<string>();
  readonly infoDialogObservable$: Observable<string> = this.infoDialogSubject.asObservable();

  private warningDialogSubject: Subject<string> = new Subject<string>();
  readonly warningDialogObservable$: Observable<string> = this.warningDialogSubject.asObservable();


  constructor() {
  }

  openConfirmDialog(onConfirm: () => void, onDecline?: () => void, title?: string) {
    this.confirmDialogSubject.next({
      onConfirm,
      onDecline,
      titleKey: title,
    });
  }

  openInfoDialog(infoText: string) {
    this.infoDialogSubject.next(infoText);
  }

  openWarningDialog(warningText: string) {
    this.warningDialogSubject.next(warningText);
  }
}
